import type {ColorMode, Kind} from './types';
import {ColorPalette} from './colorPalette';

/**
 * Resolves the color for a {@link Kind} / {@link ColorMode} combination,
 * backed directly by {@link ColorPalette}.
 */
export const KindColors: {
  [kind in Exclude<Kind, 'inherit'>]: {[mode in ColorMode]: string};
} = {
  primary: {
    main: ColorPalette.burgundy,
    light: ColorPalette.offWhite,
    dark: ColorPalette.burgundy,
  },
  secondary: {
    main: ColorPalette.warmGreen,
    light: ColorPalette.warmGreen,
    dark: ColorPalette.warmGreen,
  },
  error: {
    main: ColorPalette.error,
    light: ColorPalette.error,
    dark: ColorPalette.error,
  },
  info: {
    main: ColorPalette.info,
    light: ColorPalette.info,
    dark: ColorPalette.info,
  },
  success: {
    main: ColorPalette.success,
    light: ColorPalette.success,
    dark: ColorPalette.success,
  },
  warning: {
    main: ColorPalette.warning,
    light: ColorPalette.warning,
    dark: ColorPalette.warning,
  },
  disabled: {
    main: ColorPalette.warmGreen,
    light: ColorPalette.warmGreen,
    dark: ColorPalette.warmGreen,
  },
};

export const kindColor = (
  kind: Kind = 'primary',
  mode: ColorMode = 'main',
): string => (kind === 'inherit' ? 'inherit' : KindColors[kind][mode]);
